import React from 'react';

import Section from "../Section";
import Tile from "../Tile";

export default function TagGrid(props) {
  const Tag = props.tag;
  return <div className="mdl-grid">
    {
      props.source.map((e, i) => <Tag key={i} img={`${props.path}${e}`} />)
    }
  </div>
}



// WEBPACK FOOTER //
// ./src/TagGrid/TagGrid.js